export default {
    namespaced: true,
    state: {
        busy: false,
        outstandingRequests: 0,
        globalSearch: false,
        mobileMode: false,
        showContentArea: true,
        newVersionAvailable: false,
        user: {},
        tenant: {},
    },
    mutations: {
        incrementOutstandingRequests(state) {
            state.outstandingRequests++;
        },
        decrementOutstandingRequests(state) {
            state.outstandingRequests--;
        },
        enableMobileMode(state) {
            state.mobileMode = true;
        },
        disableMobileMode(state) {
            state.mobileMode = false;
        },
        hideContentArea(state) {
            state.showContentArea = false;
        },
        showContentArea(state) {
            state.showContentArea = true;
        },
        hideGlobalSearch(state) {
            state.globalSearch = false;
        },
        showGlobalSearch(state) {
            state.globalSearch = true;
        },

        setUser(state, data) {
            state.user = data;
        },

        setTenant(state, data) {
            state.tenant = data;
        },

        loadUser(state) {
            let user = JSON.parse(localStorage.getItem('user'));

            if (user) {
                state.user = user;
            }
        },

        resetUser(state) {
            state.user = {};
        },

        setNewVersionAvailable(state) {
            state.newVersionAvailable = true;
        },
    },
    actions: {
        increaseOutstandingRequests({ commit }) {
            commit('incrementOutstandingRequests');
        },

        decreaseOutstandingRequests({ commit }) {
            commit('decrementOutstandingRequests');
        },

        detectMobileMode({ commit }, payload) {
            if (payload.width && payload.width < 768) {
                commit('enableMobileMode');
            } else {
                commit('disableMobileMode');
            }
        },

        hideContentArea({ commit }) {
            commit('hideContentArea');
        },

        showContentArea({ commit }) {
            commit('showContentArea');
        },

        showGlobalSearch({ commit }) {
            commit('showGlobalSearch');
        },

        hideGlobalSearch({ commit }) {
            commit('hideGlobalSearch');
        },
    },
    getters: {
        app(state) {
            return state;
        },
    },
};
